module.exports = __webpack_public_path__ + "static/exponential-growth_fr-2ce5f2c73601256ffd03fa5914f6c487.svg";